import * as React from "react";
import { useLayoutEffect, useRef } from "react";

export const DEFAULT_FOCUS_POINT = "default-focus-point";

/*
 * to capture focus in modal popup even if its content is not loaded yet
 * e.g. for lazy loaded components
 * or for regular components, that don't render any content until data is loaded
 */
export const DefaultFocusPoint: React.FC<{ container: HTMLElement }> = ({ container }) => {
    const ref = useRef<HTMLDivElement>();

    useLayoutEffect(() => {
        // do nothing if focus already in container.
        if (document.activeElement && container.contains(document.activeElement)) {
            return;
        }

        ref.current.focus();
    }, []);

    return <div tabIndex={-1} ref={ref} className={DEFAULT_FOCUS_POINT} />;
};
